import { z } from "zod";

export const InternalMessagingControllerResponseSchema = {
  checkAuth: z.object({
    auth: z.object({
      userId: z.string(),
      accountId: z.string(),
      tenantIds: z.string().array(),
      email: z.string(),
    }),
  }),
};
